// src/components/RfiReviseDial.js
import React, { useState, useContext, useRef } from "react";
import { ProjectContext } from "../../App";
import api from "../../api/axiosConfig";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
export default function RfiReviseDial({
  rfiNumber,
  rfiReviseQueryNumber,
  rfiQueryToRevise,
  rfiToRevise,
  setRfiReviseDial,
  userDetails,
}) {
  const { dialBoxopen } = useContext(ProjectContext);
  const [newQueryText, setNewQueryText] = useState("");
  const inputRef = useRef();
  const [files, setFiles] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notifyClient, setNotifiyClient] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const handleFiles = (files) => {
    const newFiles = Array.from(files).map((file) => {
      const renamedFile = new File(
        [file],
        `${rfiReviseQueryNumber} ${file.name}`,
        {
          type: file.type,
          lastModified: file.lastModified,
        }
      );

      return {
        file: renamedFile,
        file_name: renamedFile.name,
        size: renamedFile.size,
        file_lastModified: renamedFile.lastModified,
        preview: URL.createObjectURL(renamedFile),
        isImage: renamedFile.type.startsWith("image"),
        isPdf: renamedFile.type === "application/pdf",
      };
    });

    // Push directly into the array (not inside arr)
    setFileList((prev) => [...prev, ...newFiles]);

    // Raw files as well
    setFiles((prev) => [...prev, ...newFiles.map((x) => x.file)]);
  };
  const removeFile = (idx) => {
    const updated = fileList.filter((_, i) => i !== idx);
    setFileList(updated);
    setFiles(updated.map((x) => x.file));
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleFiles(e.dataTransfer.files);
  };
  const handleSubmit = async () => {
    try {
      const frontendURL = window.location.origin;
      const data = {
        query_text: newQueryText,
        parent_query: rfiQueryToRevise.id,
        raised_by: userDetails.id,
        notifyClient,
        frontendURL,
      };
      setLoading(true);
      const res = await api.post(`/api/rfi/revision/${rfiToRevise}`, data);
      if (files && files.length > 0) {
        const fd = new FormData();
        for (let f of files) fd.append("files", f);

        await api.post(`/api/rfis/${rfiToRevise}/attachments`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          },
        });
      }
      setLoading(false);
      setRfiReviseDial(false);
      setNotifiyClient(false);
      setFileList([]);
      setFiles([]);
    } catch (err) {
      console.error("Error:", err);
    }
  };
  if (loading)
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        {/* Spinner */}
        <div className="w-12 h-12 border-4 border-gray-300 rounded-full border-t-blue-500 animate-spin"></div>

        {/* Loading Text */}
        {fileList.length === 0 && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <span className="loading-animation">LOADING...</span>
          </div>
        )}

        {/* Upload Progress */}
        {fileList.length > 0 && (
          <div className="w-64 mt-6">
            <p className="mb-2 text-sm text-center text-gray-600">
              Uploading: {uploadProgress}%
            </p>

            <div className="w-full h-3 overflow-hidden bg-gray-200 rounded-full">
              <div
                className="h-full transition-all duration-300 bg-green-500"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
    );
  return (
    <div className={`rfi-rev-overlay ${dialBoxopen ? "open" : "close"}`}>
      <div className="rfi-dialog">
        <div className="font-normal bg-[#f5f5f5] p-2 pl-[1rem] h-[30px] rounded-t-lg items-center top-0 left-0 z-2 flex flex-row justify-between">
          <h3 className="bg-transparent m-0 text-[15px]">Revise Query</h3>
        </div>

        <div className="rfi-dialog-body">
          <div className="rfi-info">
            <p>
              <strong className="text-black">RFI No:</strong> {rfiNumber}
            </p>
            <p>
              <strong className="text-black">Query No:</strong>{" "}
              {rfiReviseQueryNumber}
            </p>
          </div>

          <div className="rfi-original-query">
            <label>Original Query</label>
            <p className="rfi-query-text">{rfiQueryToRevise.query_text}</p>
          </div>
          <div className="flex">
            <div
              className="flex flex-col items-center justify-center w-[50%] p-3 h-52 text-center transition border-2 border-gray-400 border-dashed rounded-lg cursor-pointer w- hover:border-blue-500"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onClick={() => inputRef.current.click()}
            >
              <p className="flex flex-col gap-2 text-sm text-gray-600">
                <p className="m-0">Drag & drop files here</p>
                <p className="m-0">-OR-</p>
                <span className="h-auto w-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-[#6200ee] cursor-pointer font-lato text-[13px]">
                  Browse files
                </span>
              </p>
            </div>
            {/* Hidden Input */}
            <input
              type="file"
              multiple
              ref={inputRef}
              className="hidden"
              onChange={(e) => handleFiles(e.target.files)}
            />
            {/* Preview Section */}
            {fileList.length > 0 && (
              <div className="flex flex-col w-full gap-3 max-h-[50%] h-52 min-h-[220px] overflow-auto pb-4 px-4">
                {fileList
                  .filter((f) =>
                    f.file_name.startsWith(rfiReviseQueryNumber + " ")
                  )
                  .map((item, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col p-2 border rounded-md shadow-lg bg-gray-50"
                    >
                      {item.type && item.type.startsWith("image/") ? (
                        <img
                          src={item.preview}
                          alt={item.file.name}
                          className="object-cover w-full h-32 border rounded-md"
                        />
                      ) : item.type && item.type === "application/pdf" ? (
                        <iframe
                          src={item.preview}
                          className="w-full h-32 border rounded-md"
                          title="PDF Preview"
                        />
                      ) : (
                        // <div className="flex items-center justify-center w-full h-32 text-sm text-gray-700 bg-gray-200 rounded-md">
                        //   NO PREVIEW
                        // </div>
                        <div></div>
                      )}

                      {/* File Info */}
                      <div className="flex items-center justify-between w-full bg-transparent">
                        <div className="flex flex-col w-full bg-transparent">
                          <p className="w-[440px] text-sm font-medium truncate bg-transparent ">
                            {rfiQueryToRevise
                              ? item.file_name
                              : item.file?.name}{" "}
                          </p>
                          <p className="m-0 text-xs text-gray-600 bg-transparent">
                            {rfiQueryToRevise
                              ? (item.size / 1024).toFixed(1)
                              : (item.file?.size / 1024).toFixed(1)}{" "}
                            KB
                          </p>
                        </div>
                        <div className="flex items-center gap-4 bg-transparent">
                          {rfiQueryToRevise && item.id && (
                            <a
                              href={item.share_url}
                              target="_blank"
                              className=" text-[#6200ee]  bg-transparent rounded-md "
                            >
                              <IoEyeOutline className="bg-transparent" />
                            </a>
                          )}
                          {/* Remove Button */}
                          {!item.id && (
                            <button
                              className="text-sm text-red-500 bg-transparent border-none cursor-pointer hover:underline"
                              onClick={() => removeFile(idx)}
                            >
                              {/* Remove */}
                              <RiDeleteBin6Line
                                className="bg-transparent"
                                size={20}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
          <div className="rfi-revision-input">
            <label>Revised Query</label>
            <textarea
              value={newQueryText}
              onChange={(e) => setNewQueryText(e.target.value)}
              placeholder="Enter revised query here..."
              className="revise-query-textarea"
            ></textarea>
          </div>
          <div>
            <input
              type="checkbox"
              id="notification"
              checked={notifyClient}
              onChange={(e) => setNotifiyClient(e.target.checked)}
            />
            <label htmlFor="notification">
              Notify the client (only after the final query revision is
              completed)
            </label>
          </div>
        </div>

        <div className="rfi-dialog-footer">
          <button
            className="rfi-btn-cancel"
            onClick={() => {
              setRfiReviseDial(false);
              setNotifiyClient(false);
            }}
          >
            Cancel
          </button>
          <button className="rfi-btn-save" onClick={handleSubmit}>
            Save Revision
          </button>
        </div>
      </div>
    </div>
  );
}
